import { render, staticRenderFns } from "./MobileCommunityQnaDetail.vue?vue&type=template&id=021c1d19&scoped=true&"
import script from "./MobileCommunityQnaDetail.vue?vue&type=script&lang=js&"
export * from "./MobileCommunityQnaDetail.vue?vue&type=script&lang=js&"
import style0 from "./MobileCommunityQnaDetail.vue?vue&type=style&index=0&id=021c1d19&scoped=true&lang=css&"
import style1 from "./MobileCommunityQnaDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021c1d19",
  null
  
)

export default component.exports